import React, { useState } from "react";
import "./Withdrawal_History_card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import {
  encodeId,
  formatAmount,
  formatNotifDate,
} from "../../../../utils/common";
import { useNavigate } from "react-router-dom";

function Withdrawal_History_card({
  badge = "Withdraw",
  withdrawHistory,
  showQuery,
}) {
  const [copiedIndex, setCopiedIndex] = useState(null);

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 2000);
  };

  // Badge background color
  const badgeStyle = {
    backgroundColor: badge === "Withdraw" ? "#F56664" : "#009A55",
    color: "#fff",
  };

  // Status color based on RequestStatus.name
  const getStatusStyle = (statusName) => ({
    color:
      statusName === "Accepted"
        ? "#37BB80"
        : statusName === "Rejected"
        ? "#F56664"
        : statusName === "Processing"
        ? "#FF8000"
        : "#70798F",
  });

  const navigate = useNavigate();

  const whereToNavigate = async (id, toQuery) => {
    if (toQuery) {
      navigate(`/progress-query`);
      return;
    }
    navigate(`/withdrawal-problem/${encodeId(id)}`);
  };

  return (
    <section className="Withdrawal_card_holder">
      {withdrawHistory?.data?.map((card, index) => {
        const statusName = card?.RequestStatus?.name || "-";

        return (
          <div className="Withdrawal_card" key={card.id}>
            <div className="card-top">
              {/* Badge */}
              <span className="badge-withdraw" style={badgeStyle}>
                Withdraw
              </span>

              {/* Status from RequestStatus.name */}
              <span
                className="status-completed"
                style={getStatusStyle(statusName)}
              >
                {statusName}
              </span>
            </div>

            <div className="card-body">
              <div className="row-item">
                <span className="label">Balance</span>
                <span className="value amount">
                  {formatAmount(card?.amount)}
                </span>
              </div>
              {card?.ac_no && (
                <div className="row-item">
                  <span className="label">Account no.</span>
                  <span className="value">
                    {card?.ac_no || card?.ifsc_code || ""}
                  </span>
                </div>
              )}
              {card?.usdt_address && (
                <div className="row-item">
                  <span className="label">USDT Address.</span>
                  <span className="value">{card?.usdt_address || ""}</span>
                </div>
              )}
              {/* <div className="row-item">
                <span className="label">Platform fee</span>
                <span className="value">{formatAmount(card?.platform_fee)}</span>
              </div> */}
              <div className="row-item">
                <span className="label">Time</span>
                <span className="value">
                  {formatNotifDate(card?.createdAt)}
                </span>
              </div>

              <div className="row-item">
                <span className="label">Order number</span>
                <div className="value order-id">
                  <span className="order-text">{card?.order_no}</span>
                  <div
                    className="copy-wrapper"
                    onClick={() => handleCopy(card?.order_no, index)}
                  >
                    <FontAwesomeIcon icon={faCopy} className="copy-icon" />
                    {copiedIndex === index && (
                      <div className="copy-tooltip">Copied!</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row-item remark_box">
                <span className="label text-dark">
                  {" "}
                  <b>Remark :</b>
                </span>
                <span className="value">{card?.remark || ""}</span>
              </div>

              {!showQuery && statusName === "Accepted" && (
                <div className="btn_holder">
                  <button
                    className="orange_btn"
                    onClick={() =>
                      whereToNavigate(card?.id, card?.Withdraw_Query)
                    }
                  >
                    Submit PDF Bank Statement
                  </button>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </section>
  );
}

export default Withdrawal_History_card;
